// @flow
import { useContext } from 'react';
import RightsByOrgContext from './RightsByOrgContext';

const useRightsByOrgData = () => useContext(RightsByOrgContext);
export default useRightsByOrgData;
